import { Injectable, Injector, inject } from '@angular/core';
import { Settings } from './settings';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '../../appconfig';
import { WebdokuService } from '../../web-doku/webdoku.service';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { AppUrls } from '../../route/app-urls';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { SettingsFactory } from './settings-factory';
import { KeyValuePair } from '../models/key-value-pair';
import { Router } from '@angular/router';
import { UserSettingsDto } from '../dto/user-settings-dto';
import { UserInformationService } from '../../shell/user-information.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private http = inject(HttpClient);
  private config = inject(AppConfig);
  private webdokuService = inject(WebdokuService);
  private translate = inject(TranslateService);
  private userInformationService = inject(UserInformationService);
  private router = inject(Router);

  public settings!: Settings;
  subscription: Subscription = new Subscription();

  public settingsLoaded: Subject<boolean> = new Subject<boolean>();

  constructor() {
    this.settings = new Settings(this.config, this.webdokuService, this.translate);
    this.subscription.add(this.settings.settingsChanged.subscribe((val) => this.settingsChanged(val)));
    this.subscription.add(
      this.router.events.subscribe(() => {
        // reset fullscreen mode when route changes
        this.settings.viewMode.isFullScreen = false;
      })
    );
  }

  public getSettings(): Observable<boolean> {
    return this.http.get<UserSettingsDto>(AppUrls.getApiUrl(AppUrls.urlSettings, 'get')).pipe(
      map((dtoRaw) => {
        this.userInformationService.userInformation.LoginName = dtoRaw.userName;
        this.userInformationService.userInformation.DisplayName = dtoRaw.displayName;
        this.settings.settingsList = SettingsFactory.fromDTO(dtoRaw.items);
        this.settings.parseAndApplySettingsList();
        this.settingsLoaded.next(true);
        return true;
      }),
      catchError(() => {
        this.settings.settingsList = [];
        return of(false);
      })
    );
  }

  private settingsChanged(val: KeyValuePair) {
    if (val == null) {
      return;
    }
    const arr = [];
    arr.push(val);
    this.http
      .post<KeyValuePair>(AppUrls.getApiUrl(AppUrls.urlSettings, 'save'), JSON.stringify(arr))
      .pipe()
      .subscribe();
  }

  public IsFullScreen(){
    return this.settings.viewMode.isFullScreen || this.IsRunningInWindowModeAndOpenInNewTabMode();
  }

  public IsRunningInWindowModeAndOpenInNewTabMode(){
    return this.RunningInWindowMode() && this.settings.documentMode.openDocInNewTab
  }

  public RunningInWindowMode() {
    return navigator.userAgent.indexOf('LDW-Window-Android') != -1;
  }
}
